export default __webpack_public_path__ + "static/media/006.61186700.png";